import MatuckshopDetails from '../components/TuckshopDetails'
import {useEffect, useState} from 'react'
import {useTuckshopContext} from "../hooks/useTuckshopContext"

const Matuckshop= () => {

    const {tuckshops, dispatch}= useTuckshopContext()


useEffect(() => {
 const fetchtuckshops = async () => {
    const response = await fetch('https://webservicetry1.onrender.com/matuckshop/home')
    const json = await response.json()

    if (response.ok) { 
        dispatch({type:'set_tuckshops',payload:json})
    }
 }
fetchtuckshops()
}, [dispatch])

return (
    <div className='matuckshop'>

    <div className='tuckshops'> 
    {tuckshops && tuckshops.map((tuckshop) => ( 
    
    <MatuckshopDetails key={tuckshop._id} tuckshop ={tuckshop}/> 
))}

    </div>
    </div>
)
}

export default Matuckshop